import React, { lazy, Suspense } from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'
import { routerUtil } from '@utils/config'
import { Loading } from '@com-components/'

const Thesaurus = lazy(() => import('@pages/manager/thesaurus'))
const Website = lazy(() => import('@pages/manager/website'))
const ThesaurusWords = lazy(() => import('@pages/manager/thesaurus-words'))
const Interface = lazy(() => import('@pages/manager/statistic/interface'))
const Against = lazy(() => import('@pages/manager/statistic/against'))
const AgainstData = lazy(() => import('@pages/manager/statistic/against-data'))
const ContentReview = lazy(() => import('@pages/manager/statistic/content-review'))

export const routerConfig = [
  {
    name: '设置管理',
    children: [
      {
        name: '黑词文本管理',
        path: '/manager/thesaurus/words/:id',
        hideInMenu: true,
        component: ThesaurusWords
      },
      { name: '词库管理', path: '/manager/thesaurus', component: Thesaurus },
      { name: '网址/域名/IP管理', path: '/manager/website', component: Website }
    ]
  },
  {
    name: '数据统计',
    children: [
      { name: '接口数据统计', path: '/manager/statistic/interface', component: Interface },
      { name: '违规数据明细', path: '/manager/statistic/against-list', component: Against },
      { name: '风控拦截数据', path: '/manager/statistic/against-data', component: AgainstData }, // 用于代替违规数据明细
      { name: '内容审核', path: '/manager/statistic/content-review', component: ContentReview },
    ]
  }
]
const routerMap = routerUtil.sortToRoute(routerConfig)
const ManagerRoutes = () => (
  <Suspense fallback={<Loading />}>
    <Switch>
      {routerMap.map(route => (
        <Route key={route.path} path={route.path} component={route.component} />
      ))}
      <Redirect to="/manager/thesaurus" />
    </Switch>
  </Suspense>
)

export default ManagerRoutes
